import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import InboxTransitionBase from './InboxTransitionBase';
import { getFirstName } from '../../util/user';

const InboxTransitionCustomerCancelWithRefund = ({ transition, user, ownRole, buttons }) => {
  const isOwnTransition = transition.by === ownRole;
  const displayName = getFirstName(get(user, 'attributes.profile.displayName', ''));

  return (
    <InboxTransitionBase
      date={transition.createdAt}
      direction="left"
      header={
        isOwnTransition ? (
          <FormattedMessage id="BookingStatus.ownCustomerCancelWithRefund" />
        ) : (
          <FormattedMessage
            id="BookingStatus.transitionCustomerCancelRefund"
            values={{ displayName }}
          />
        )
      }
      buttons={buttons}
    >
      {isOwnTransition ? null : (
        <FormattedMessage
          id="BookingStatus.transitionCustomerCancelRefundSubtext"
          values={{ displayName }}
        />
      )}
    </InboxTransitionBase>
  );
};

export default InboxTransitionCustomerCancelWithRefund;
